export default "__VITE_ASSET__jkQzLsnb__"